import { IHostVoiceDTO } from '@/modules/episodes/dtos/host.dto';
import { IHostVoice } from '@/modules/episodes/entities/host.entity';

export class HostMapper {
  public static toPresentation(dto: IHostVoiceDTO): IHostVoice {
    return {
      id: dto.id,
      name: dto.nome,
      slug: dto.slug,
      gender: dto.genero,
      hostName: dto.nomeHost,
    };
  }
}
